const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMutation = require('app/graphql/Mutation');

const CreateModal = require('app/product/CreateModal');
const ExcelModal = require('app/product/export/ExcelModal');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-product-list',
            'tableContainerSelector': '.product-list-container',
            'filterFormSelector': '.product-list-search-form',

            'productShowBaseUrl': window.App.get('productShowBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.onClickCreate = this.onClickCreate.bind(this);
        this.onClickExport = this.onClickExport.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        this.$btnCreate = $('.btn-product-create');
        this.$btnExport = $('.btn-product-export');

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
        this.initializeListTable();
        this.bindEvents();
    }

    initializeFilterForm(){
        var self = this;

        this.$filterRange = $('select[name="range"]',this.$filterForm); 
        this.$filterRange.on('change',this.onSubmitFilterForm);

        this.$filterByNumber = $('input[name="number"]',this.$filterForm);
        this.$filterByNumber.on('change',this.onSubmitFilterForm);

        this.$filterByReference = $('input[name="reference"]',this.$filterForm);
        this.$filterByReference.on('change',this.onSubmitFilterForm);

        this.$filterByRange = $('select[name="range"]',this.$filterForm);
        this.$filterByRange.on('change',this.onSubmitFilterForm);

        this.$filterBySupplier = $('select[name="supplier"]',this.$filterForm);
        this.$filterBySupplier.on('change',this.onSubmitFilterForm);

        this.$filterByStatus = $('select[name="status"]',this.$filterForm); 
        this.$filterByStatus.on('change',this.onSubmitFilterForm);


        this.$filterWithoutFT = $('input[name="withoutFT"]',this.$filterForm); 
        this.$filterWithoutFT.on('change',this.onSubmitFilterForm);

        this.$filterForm.on('submit',this.onSubmitFilterForm);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }


    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'number',
            'reference',
            'range { id name }',
            'supplier { id name }',
            'unit',
            'quantity',
            'supplierPrice',
            'technicalFile { url }'
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped product-list',
            'id': 'list-products',
            'length': 50,
            'graphQL': {
                'queryType': 'supplierProducts',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'number',
                    'label': window.translate('product.number.label'),
                    'orderType': 'number',
                    'class': 'product-number',
                    'render': function(item,index){
                        return item.node.number;
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('product.reference.label'),
                    'ordered': true,
                    'orderType': 'reference',
                    'orderDir': 'ASC',
                    'class': 'product-reference',
                    'render': function(item,index){
                        return item.node.reference;
                    },
                },
                {
                    'name': 'range',
                    'label': window.translate('product.range.label'),
                    'ordered': true,
                    'orderType': 'range',
                    'orderDir': 'ASC',
                    'class': 'product-range',
                    'render': function(item,index){
                        return item.node.range.name;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('product.supplier.label'),
                    'ordered': true,
                    'orderType': 'supplier',
                    'orderDir': 'ASC',
                    'class': 'product-supplier',
                    'render': function(item,index){
                        return item.node.supplier.name;
                    },
                },
                {
                    'name': 'packaging',
                    'label': window.translate('product.packaging.label'),
                    'ordered': true,
                    'orderType': 'packaging',
                    'orderDir': 'ASC',
                    'class': 'product-packaging',
                    'render': function(item,index){
                        return window.formatFloat(item.node.quantity,2) + ' / ' + item.node.unit;
                    },
                },
                {
                    'name': 'supplierPrice',
                    'label': window.translate('product.supplierPrice.label'),
                    'ordered': true,
                    'orderType': 'supplierPrice',
                    'orderDir': 'ASC',
                    'class': 'product-supplierPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.node.supplierPrice,2) + ' &euro;';
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'product-actions',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        let btns = [];

                        let urlEdit = self.settings.productShowBaseUrl.replace('__ID__',item.node.id);
                        let $btnEdit = $('<a/>')
                        .attr('href',urlEdit)
                        .addClass('btn btn-link iframe fancy')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('product.actions.edit.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-edit')
                        );
                        btns.push($btnEdit);

                        let $btnModalDelete = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-danger iframe fancy')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('product.actions.delete.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-trash')
                        )
                        .on('click',function(event){
                            self.onClickDelete(item.node);
                        });
                        btns.push($btnModalDelete);

                        if(item.node.technicalFile){
                            let urlFT = window.App.get('apiBaseUrl')+item.node.technicalFile.url;

                            let $btnShowFT = $('<a/>')
                            .attr('href',urlFT)
                            .attr('target','_blank')
                            .addClass('btn btn-link')
                            .attr('data-fancybox','')
                            .attr('data-type','iframe')
                            .attr('title',window.translate('product.actions.showFT.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-file-pdf')
                            );
                            btns.push($btnShowFT);

                        }

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildGraphQLParameters(){
        let filters = {
            'notStatus': 3,
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = '%'+this.$filterByReference.val()+'%';
        }

        if(this.$filterByRange && this.$filterByRange.val()){
            filters.rootRange = parseInt(this.$filterByRange.val());
        }

        if(this.$filterBySupplier && this.$filterBySupplier.val()){
            filters.supplier = parseInt(this.$filterBySupplier.val());
        }

        if(this.$filterByStatus && this.$filterByStatus.val()){
            filters.status = parseInt(this.$filterByStatus.val());
        }

        if(this.$filterWithoutFT.is(':checked')){
            filters.havingTechnicalFile = false;
        }

        let orderBy = 'reference';
        let dir = "ASC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    bindEvents(){
        this.$btnCreate.on('click',this.onClickCreate)
        this.$btnExport.on('click',this.onClickExport)
    }
    onClickCreate(event){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let modal = new CreateModal({
            'onSuccess': function(data){
                let product = data.product;
                let url = self.settings.productShowBaseUrl.replace('__ID__',product.id);
                window.redirect(url);
            }
        });
    }
    onClickExport(event){
        event.preventDefault();
        event.stopPropagation();
        let modal = new ExcelModal();
    }

    onClickDelete(product){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('product.actions.delete.confirm',{'%productName%':product.reference}))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDelete(product,modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();

    }

    proceedDelete(product,confirmModal){

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'product': {
                'value': product.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplierProduct",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = ListView;

